module.exports = __webpack_public_path__ + "img/katharsisPlaceholder.9b95ffee.png";